import { fetchJSON } from '@eventbrite/http';
import { formatUrl } from 'url-lib';
import { fetchThingsToDoShelfData } from '../../../../redux/actions/thingsToDoShelf';
import { buildBBox } from '../../utils';
import {
    setFeCallAsFailed,
    setFeCallAsOngoing,
    setFeCallAsSuccess,
} from '../app/actions';
import { fetchEventsForTab, fetchFeaturedPaidEvents } from '../events/actions';
import { getInitialState } from '../index';
import { UPDATE_ROOT_CONTEXT } from './rootActionTypes';

export const getRestOfContext =
    (originalContext: any) => async (dispatch: Function) => {
        dispatch(setFeCallAsOngoing());

        let response = {};
        try {
            response = await fetchJSON(formatUrl('/fe/'));
        } catch (e) {
            dispatch(setFeCallAsFailed());
        }

        const fullContext = getInitialState({
            ...originalContext,
            ...response,
        });

        const {
            content: {
                browseState: { tabKey },
            },
            location: { placeId, latitude, longitude },
        } = fullContext;

        dispatch(
            fetchFeaturedPaidEvents({
                placeId: placeId || '',
                isFlagEnable:
                    fullContext.app.featureFlags?.enableFeaturedEvents || false,
            }),
        );
        dispatch({
            type: UPDATE_ROOT_CONTEXT,
            payload: fullContext,
        });
        dispatch(
            fetchEventsForTab({
                tabKey,
                locationData: {
                    placeId: placeId || '',
                    bbox:
                        latitude && longitude
                            ? buildBBox({ latitude, longitude })
                            : undefined,
                },
                shouldUpdateContent: true,
            }),
        );
        dispatch(fetchThingsToDoShelfData());
        dispatch(setFeCallAsSuccess());
    };
